import groupBy from 'lodash/groupBy';
import orderBy from 'lodash/orderBy';

import { SearchableTreeData, TreeData } from './CommonTreeSelect';

/**
 * This is a helper method, which is used to get nice looking count of children
 * which belong to particular parent after search, user to understand how many
 * items are hidden because of search.
 *
 * @param { SearchableTreeData[] } array - list of TreeData objects with search
 * field, which will be used for filtering items
 * @param { string } groupKey - parent id key on SearchableTreeData elements
 * using this key we make our data hierarchical so on top we have parents.
 * @param { (key: string, value: SearchableTreeData[]) => TreeData): TreeData[] } groupFunction
 * callback that is called for every child component for every parent to remap it to be TreeData
 *
 * @return { TreeData[] } list of TreeData objects in hierarchical notation
 * (not flat, tree with leafs) which is ok for TreeSelect component.
 */
const createGroupedArray = (
  array: SearchableTreeData[],
  groupKey,
  groupFunction: (key: string, value: SearchableTreeData[]) => TreeData,
): TreeData[] => {
  const groupedArray: { [key: string]: SearchableTreeData[] } = groupBy(
    array,
    groupKey,
  );

  return orderBy(
    Object.keys(groupedArray)
      .map((serviceType: string) => {
        const vehicles: SearchableTreeData[] = groupedArray[serviceType];

        return groupFunction(serviceType, vehicles);
      })
      .filter(({ children }: TreeData) => children.length),
    ['children.length'],
    ['asc'],
  );
};

export default createGroupedArray;
